import React from 'react'
import googleLogo from '../../icons/socials/google.svg'
import { translate } from '../../utils/translator';

interface Props {
  redirectPath: string;
  cameFromPath: string;
  language: string;
  country: string;
  customerVerificationType?: string;
  /** Optional style overrides (e.g. the WL questionnaire email step matches its own Figma spec). */
  className?: string;
  labelClassName?: string;
  iconClassName?: string;
  /** Override the button copy (defaults to oauth/google_login_button_text). */
  label?: string;
  onClick?: () => void;
  id?: string;
}

const GoogleLoginButton: React.FC<Props> = ({
  redirectPath,
  cameFromPath,
  language,
  country,
  customerVerificationType,
  className,
  labelClassName,
  iconClassName,
  label,
  onClick,
  id,
}) => {

  const handleGoogleLogin = async () => {
    try {
      onClick?.();
      // Get the Google OAuth URL
      let authUrl = `${process.env.REACT_APP_API_URL}/auth/google`;
      
      // Build URL with query parameters
      const url = new URL(authUrl);
      
      // Add redirectPath if provided
      if (redirectPath) {
        url.searchParams.append('redirectPath', redirectPath);
      }

      // Add customerVerificationType if provided
      if (customerVerificationType) {
        url.searchParams.append('customerVerificationType', customerVerificationType);
      }

      // Add cameFromPath if provided
      if (cameFromPath) {
        url.searchParams.append('cameFromPath', cameFromPath);
      }

      // Add language and country
      url.searchParams.append('language', language);
      url.searchParams.append('country', country);

      authUrl = url.toString();
      // Redirect to Google OAuth page
      window.location.href = authUrl;
    } catch (error) {
      window.clientLogger.error('Error initiating Google login:', error);
    }
  }

  return (
    <button
      id={id}
      onClick={handleGoogleLogin}
      type='button'
      className={
        className ??
        "flex items-center gap-[8px] justify-center w-full py-[20px] px-8 bg-[#F5F6F7] rounded-[12px] shadow-[0_12px_18px_#CED0D8B2] cursor-pointer hover:opacity-80 transition-opacity duration-300 border-none outline-none"
      }
    >
      <img src={googleLogo} alt="Google logo" className={iconClassName ?? "w-[20] aspect-square"} />
      <p className={labelClassName ?? 'text-[16px] md:text-[20px] font-[400] text-[#08080A] font-poppins'}> {label ?? translate(language, "default", "oauth/google_login_button_text")} </p>
    </button>
  )
}

export default GoogleLoginButton